<div class="quotations-cntr">

  <ct-search-filters [configuration]="filtersConfiguration" (filter)="filter($event)"></ct-search-filters>

  <ng-container *ngIf="items.length > 0; else emptyQuotationsTemplate">

    <app-cart-order *ngFor="let order of items" [configuration]="order" (refresh)="fetch()"></app-cart-order>

    <div class="button-cntr" *ngIf="hasQuoteApprover">
      <button mat-raised-button color="primary" (click)="openPreview()">Approva tutti</button>
    </div>

  </ng-container>

  <ng-template #emptyQuotationsTemplate>
    <p class="text-center">Non ci sono preventivi da approvare.</p>
  </ng-template>


</div>